import api from './api';

const withStore = (storeId, authContext) => ({
  ...(storeId ? { _storeId: storeId } : undefined),
  ...(authContext ? { _authContext: authContext } : undefined),
});

const WaitlistService = {
  join: async (payload, storeId) => {
    const response = await api.post('/waitlist', payload, withStore(storeId));
    return response.data;
  },

  getMine: async (storeId) => {
    const response = await api.get('/waitlist', withStore(storeId));
    return response.data;
  },

  leave: async (storeId) => {
    await api.delete('/waitlist', withStore(storeId));
  },

  getWindows: async (date, storeId) => {
    const response = await api.get('/waitlist/windows', {
      params: { date },
      ...withStore(storeId),
    });
    return response.data;
  },

  getQueue: async (storeId) => {
    const response = await api.get('/waitlist/entries', withStore(storeId, 'management'));
    return response.data;
  },

  removeEntry: async (entryId, storeId) => {
    await api.delete(`/waitlist/entries/${entryId}`, withStore(storeId, 'management'));
  },

  getOffer: async (token, storeId) => {
    const response = await api.get(`/waitlist/offers/${encodeURIComponent(token)}`, withStore(storeId));
    return response.data;
  },

  bookOffer: async (token, storeId) => {
    await api.post(`/waitlist/offers/${encodeURIComponent(token)}/book`, {}, withStore(storeId));
  },

  declineOffer: async (token, storeId) => {
    await api.post(`/waitlist/offers/${encodeURIComponent(token)}/decline`, {}, withStore(storeId));
  },

  claimOffer: async (offerId, storeId) => {
    await api.post(`/waitlist/offers/${offerId}/claim`, {}, withStore(storeId));
  },
};

export default WaitlistService;
